import { useEffect } from "react";

import { useLocation } from "react-router-dom";

import { highlightElement } from "@/utils/highlightElement";

/**
 * ScrollToTop
 * scrolls to the top of the page instantly as the user routes. Prevent the weird
 * default when a user is left hanging at the scroll position on the previous page.
 * If there's a hash in the URL, scroll to the element with that ID.
 */

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait for React to render the page before scrolling
      setTimeout(() => {
        const element = document.getElementById(hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          // Apply highlight effect
          highlightElement(element);
        } else {
          window.scrollTo(0, 0);
        }
      }, 300); // Longer timeout to ensure content is fully rendered
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
